import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { asyncCheckDuplicate, renderInput } from 'src/components/misc/redux-form-helpers';
import { Entities, TOMCAT_URL } from 'src/common/index';
import { isBlank, isEmailInvalid } from 'src/components/misc/validations';

class AssociationEditForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { handleSubmit, association, isCreate, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="name" label={`${t('associations.association_name')} *`} component={renderInput} />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="registrationNumber"
                            label={`${t('associations.registration_number')} *`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="contactData.email" label={`${t('contact_data.email')}`} component={renderInput} />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="contactData.phone"
                            label={`${t('contact_data.tel_number')}`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="contactData.street"
                            label={`${t('contact_data.street')}`}
                            component={renderInput}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="contactData.postCode"
                            label={`${t('contact_data.post_code')}`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="contactData.city" label={`${t('contact_data.city')}`} component={renderInput} />
                    </div>
                </div>
                {!isCreate && (
                    <div className="row">
                        <div className="col-md-6">
                            <Field
                                name="bonusPointsGranted"
                                label={t('schools.points.granted')}
                                type="number"
                                component={renderInput}
                            />
                        </div>
                        <div className="col-md-6">
                            <Field
                                name="bonusPointsRedeemed"
                                label={t('schools.points.redeemed')}
                                type="number"
                                component={renderInput}
                            />
                        </div>
                    </div>
                )}
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {
        contactData: {},
    };

    if (values.bonusPoints == null) errors.bonusPoints = t('error_missing.fill_in');
    else if (values.bonusPoints < 0) errors.bonusPoints = t('error_hint.error_negative');

    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');
    if (isBlank(values.registrationNumber)) errors.registrationNumber = t('associations.fill_in_registration_number');
    if (values.contactData) {
        if (isEmailInvalid(values.contactData.email) && !isBlank(values.contactData.email))
            errors.contactData.email = t('error_hint.error_invalid_email');
    }

    return errors;
};

const asyncValidate = (values, dispatch, props) => {
    return asyncCheckDuplicate(
        props.t,
        `${TOMCAT_URL}api/${Entities.ASSOCIATION.repository}/search/findByName?name=${encodeURIComponent(values.name)}`,
        values.id,
        'name',
    );
};

AssociationEditForm = reduxForm({
    form: 'associationEditForm',
    validate,
    asyncValidate,
    asyncBlurFields: ['name'],
})(AssociationEditForm);

const selector = formValueSelector('associationEditForm');

const mapStateToProps = (state, ownProps) => {
    const { association, isCreate } = ownProps;

    let initialValues = {};

    if (!isCreate && association) {
        initialValues = {
            id: association.id,
            bonusPoints: association.bonusPoints,
            name: association.name,
            registrationNumber: association.registrationNumber,
            contactData: {
                email: association.contactData.email,
                phone: association.contactData.phone,
                street: association.contactData.street,
                postCode: association.contactData.postCode,
                city: association.contactData.city,
            },
            bonusPointsGranted: association.bonusPointsGranted,
            bonusPointsRedeemed: association.bonusPointsRedeemed,
        };
    }

    return {
        initialValues,
    };
};

AssociationEditForm = connect(mapStateToProps, null, null, { withRef: true })(AssociationEditForm);

export default AssociationEditForm;
